export const CaretUpIcon = (props: any) => {
    return (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="#9B9B9B" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M9.46854 8.0625H1.53146C1.2934 8.0625 1.16047 7.81114 1.3079 7.63954L5.27644 3.03778C5.39003 2.90606 5.60876 2.90606 5.72356 3.03778L9.6921 7.63954C9.83953 7.81114 9.7066 8.0625 9.46854 8.0625Z"/>
        </svg>
    )
}